import Navbar from "../components/Navbar";
import Chapter2thongtin from "./Chapter2thongtin";
function Chapter2(){
    return(
        <>
        <Navbar/>
        <Chapter2thongtin/>
        </>
    )
}
export default Chapter2;